/* ============================================================
   Santamadre MX — PDP behavior
   - Galería (thumbnail -> imagen principal)
   - Selector de variantes (sabor / cantidad) nativo de Shopify
   - Stepper de cantidad
   - Add to cart (AJAX) + Comprar ahora
   Datos por sección en window.__pdpData[sectionId]
   ============================================================ */
(function () {
  'use strict';

  function money(cents, fmt) {
    // fmt viene de Shopify (money_format), pero usamos un fallback simple es-MX
    var value = (cents / 100).toLocaleString('es-MX', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return '$' + value;
  }

  function initRoot(root) {
    var sectionId = root.getAttribute('data-pdp-root');
    var data = (window.__pdpData || {})[sectionId];
    if (!data) return;

    var variants = data.variants || [];

    /* ---------- Galería ---------- */
    var mainImg = root.querySelector('[data-pdp-main-img]');
    root.querySelectorAll('[data-pdp-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (full && mainImg) {
          mainImg.style.opacity = '0';
          setTimeout(function () {
            mainImg.src = full;
            if (thumb.getAttribute('data-srcset')) mainImg.srcset = thumb.getAttribute('data-srcset');
            mainImg.style.opacity = '1';
          }, 120);
        }
        root.querySelectorAll('[data-pdp-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    /* ---------- Selector de variantes ---------- */
    var idInput = root.querySelector('[data-pdp-variant-id]');
    var priceEl = root.querySelector('[data-pdp-price]');
    var compareEl = root.querySelector('[data-pdp-compare]');
    var atcBtn = root.querySelector('[data-pdp-atc]');
    var buyNowBtn = root.querySelector('[data-pdp-buynow]');

    // Estado de opciones seleccionadas (por posición 1..N)
    var selected = [];
    root.querySelectorAll('[data-pdp-optgroup]').forEach(function (group) {
      var pos = parseInt(group.getAttribute('data-pdp-optgroup'), 10);
      var active = group.querySelector('[data-pdp-optvalue].is-active');
      selected[pos - 1] = active ? active.getAttribute('data-value') : null;
    });

    function findVariant() {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return selected[i] == null || opt === selected[i];
        });
      });
    }

    function updateVariant() {
      var v = findVariant();
      if (!v) return;
      if (idInput) idInput.value = v.id;

      if (priceEl) priceEl.textContent = money(v.price);
      var stickyPriceEl = root.querySelector('[data-pdp-sticky-price]');
      if (stickyPriceEl) stickyPriceEl.textContent = money(v.price);
      if (compareEl) {
        if (v.compareAt && v.compareAt > v.price) {
          compareEl.textContent = money(v.compareAt);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (atcBtn) {
        atcBtn.disabled = !v.available;
        var lbl = v.available ? (atcBtn.getAttribute('data-label') || 'Agregar al carrito') : 'Agotado';
        var bt = atcBtn.querySelector('[data-button-text]');
        if (bt) { bt.textContent = lbl; } else { atcBtn.textContent = lbl; }
      }
      // Actualizar imagen si la variante tiene media asociada
      if (v.media && mainImg) {
        mainImg.src = v.media;
        if (v.mediaSrcset) mainImg.srcset = v.mediaSrcset;
      }
      // Actualizar etiquetas "Opción — Valor seleccionado"
      root.querySelectorAll('[data-pdp-optlabel]').forEach(function (lbl) {
        var pos = parseInt(lbl.getAttribute('data-pdp-optlabel'), 10);
        if (selected[pos - 1] != null) lbl.textContent = selected[pos - 1];
      });
      // Sincronizar URL (?variant=) sin recargar
      if (window.history && window.history.replaceState) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url);
        } catch (e) {}
      }
    }

    root.querySelectorAll('[data-pdp-optgroup]').forEach(function (group) {
      var pos = parseInt(group.getAttribute('data-pdp-optgroup'), 10);
      group.querySelectorAll('[data-pdp-optvalue]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.classList.contains('is-soldout')) return;
          selected[pos - 1] = btn.getAttribute('data-value');
          group.querySelectorAll('[data-pdp-optvalue]').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          updateVariant();
        });
      });
    });

    /* ---------- Stepper ---------- */
    var qtyInput = root.querySelector('[data-pdp-qty]');
    var decBtn = root.querySelector('[data-pdp-dec]');
    var incBtn = root.querySelector('[data-pdp-inc]');
    function getQty() { return Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1); }
    if (decBtn) decBtn.addEventListener('click', function () { qtyInput.value = Math.max(1, getQty() - 1); });
    if (incBtn) incBtn.addEventListener('click', function () { qtyInput.value = getQty() + 1; });
    if (qtyInput) qtyInput.addEventListener('change', function () { qtyInput.value = getQty(); });

    /* ---------- Add to cart ----------
       El submit lo maneja el componente NATIVO <product-form> de Aurora
       (abre y renderiza el cart-drawer correctamente, incluido Simple Bundles). */

    /* ---------- Barra sticky precio + ATC ---------- */
    var realAtc = root.querySelector('.pdp-atc');
    var stickyBar = root.querySelector('[data-pdp-sticky]');
    var stickyAtc = root.querySelector('[data-pdp-sticky-atc]');
    if (realAtc && stickyBar) {
      // El botón sticky dispara el mismo botón nativo (mismo flujo de carrito)
      if (stickyAtc) stickyAtc.addEventListener('click', function () { realAtc.click(); });
      // Mostrar la barra solo cuando el ATC real no está visible
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            var show = !e.isIntersecting;
            stickyBar.classList.toggle('is-visible', show);
            stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
          });
        }, { threshold: 0, rootMargin: '-90px 0px 0px 0px' });
        io.observe(realAtc);
      }
      // Mantener el precio sticky sincronizado con el principal
      // (incluye el precio dinámico que actualiza Simple Bundles al cambiar selección)
      var stickyPrice = root.querySelector('[data-pdp-sticky-price]');
      if (priceEl && stickyPrice && 'MutationObserver' in window) {
        new MutationObserver(function () { stickyPrice.textContent = priceEl.textContent; })
          .observe(priceEl, { childList: true, characterData: true, subtree: true });
      }
    } else if (stickyBar) {
      stickyBar.remove();
    }

    updateVariant();
  }

  function init() {
    document.querySelectorAll('[data-pdp-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
